import {connect} from 'react-redux';
import {setSearchText, searchTemplate} from 'template/actions';
import React, {Component, Fragment} from 'react';
import {Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import autobind from 'autobind-decorator';

@connect(
    state => ({
        searchText: state.template.searchText
    }),
    dispatch => ({
        search: (searchText) => dispatch(setSearchText(searchText)),
        searchTemplate: (searchText) => dispatch(searchTemplate(searchText))
    })
)
export default class TemplateCategorySearch extends Component {

    @autobind
    onReset() {
        this.props.search('')
        this.props.searchTemplate('')
    }

    @autobind
    onChange(e) {
        this.props.search(e.target.value)
    }

    @autobind
    onEnter(e) {
        if (e.key === 'Enter') this.props.searchTemplate(this.props.searchText)
    }

    render() {
        const {
            searchText
        } = this.props;
        return (
            <Fragment>
                <InputGroup>
                    <Input sm={2} type="text" placeholder="Suche" value={searchText}
                           onChange={this.onChange}
                           onKeyPress={this.onEnter}
                    />
                    <InputGroupAddon addonType="append">
                        <Button color={'secondary'} onClick={this.onReset}>Zurücksetzen</Button>
                    </InputGroupAddon>
                </InputGroup>
            </Fragment>

        )
    }
}
